import React from 'react';
import { useIntl } from 'react-intl';

const AdminCustomFieldsListHeader = () => {
  const intl = useIntl();

  return (
    <tr>
      <th>{' '}</th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Name' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Type' })}
      </th>
      <th className="th-min-content">
        {intl.formatMessage({ defaultMessage: 'Visible on shares' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Required' })}
      </th>
      <th>
        {' '}
      </th>
    </tr>
  );
};

export default AdminCustomFieldsListHeader;
